<!-- 自增表格 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1">内容设置</MenuItem>
                <MenuItem name="2">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="left"
                        :label-width="80"
                    >
                        <div class="form-title">预设类型</div>
                        <FormItem label="字段属性">
                            <RadioGroup
                                v-model="newFormData.content.field_attribute"
                            >
                                <Radio class="mr24" label="1">必填</Radio>
                                <Radio class="mr24" label="2">不必填</Radio>
                            </RadioGroup>
                        </FormItem>
                        <div class="form-title">标题设置</div>
                        <FormItem label="内容标题">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="请输入内容标题"
                            ></Input>
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <FormItem label="边框颜色">
                            <ColorPicker
                                v-model="newFormData.content.border_color"
                            />
                        </FormItem>
                        <FormItem label="填充颜色">
                            <ColorPicker
                                v-model="newFormData.content.fill_color"
                            />
                        </FormItem>
                        <FormItem label="标题背景">
                            <ColorPicker
                                v-model="
                                    newFormData.content.title_background_color
                                "
                            />
                        </FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="按钮名称">
                            <Input
                                v-model="newFormData.content.btn_name"
                                placeholder="请输入按钮名称"
                            ></Input>
                        </FormItem>
                        <FormItem label="文字颜色">
                            <ColorPicker
                                v-model="newFormData.content.btn_text_color"
                            />
                        </FormItem>
                        <FormItem label="按钮背景">
                            <ColorPicker
                                v-model="
                                    newFormData.content.btn_background_color
                                "
                            />
                        </FormItem>
                        <FormItem label="按钮边框">
                            <ColorPicker
                                v-model="newFormData.content.btn_border_color"
                            />
                        </FormItem>
                        <div class="form-label">列设置</div>
                        <div
                            class="table-box"
                            v-for="(e, index) of newFormData.content.table_list"
                            :key="index"
                        >
                            <span v-if="fieldTypeLabel(e)" class="field-type">{{
                                fieldTypeLabel(e)
                            }}</span>
                            <Input
                                class="table-input"
                                v-model="e.label"
                                :border="false"
                                placeholder="请输入"
                            ></Input>
                            <div
                                v-if="e.type === 1"
                                class="edit-option"
                                @click="openEditOption(index)"
                            >
                                <div class="mr12">
                                    {{ optionList.length }}个选项
                                </div>
                                <Icon
                                    type="md-settings"
                                    size="18"
                                    color="#ccc"
                                />
                            </div>
                            <Icon
                                type="ios-close-circle"
                                color="#ed4014"
                                size="20"
                                class="c-p"
                                @click="delIcon(index)"
                            />
                        </div>
                        <Dropdown
                            trigger="click"
                            placement="top"
                            @on-click="addField"
                        >
                            <div class="add-status">
                                <Icon type="md-add" size="20" color="#FF761D" />
                                <span>添加</span>
                            </div>
                            <DropdownMenu slot="list">
                                <DropdownItem
                                    v-for="item in fieldTypes"
                                    :key="item.id"
                                    :name="item.id"
                                    >{{ item.name }}</DropdownItem
                                >
                            </DropdownMenu>
                        </Dropdown>
                        <div class="form-label">填写限制</div>
                        <div class="ml50 mb12">
                            默认显示
                            <Input
                                class="w50"
                                v-model="newFormData.content.default_value"
                            ></Input>
                            项
                        </div>
                        <div class="ml50 mb12">
                            最少填写
                            <Input
                                class="w50"
                                v-model="newFormData.content.min_value"
                            ></Input>
                            项
                        </div>
                        <div class="ml50 mb12">
                            最多填写
                            <Input
                                class="w50"
                                v-model="newFormData.content.max_value"
                            ></Input>
                            项
                        </div>
                        <FormItem label="隐私保护"
                            ><Checkbox
                                v-model="newFormData.content.privacy_protection"
                                >提交后对内容打码</Checkbox
                            ></FormItem
                        >
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div v-if="name_id == 2">
                <Form
                    :model="newFormData"
                    label-position="right"
                    :label-width="80"
                >
                    <div class="form-title">外间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">内间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">圆角设置</div>
                    <FormItem label="上圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting.top
                            "
                        ></Slider
                    ></FormItem>
                    <FormItem label="下圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting
                                    .bottom
                            "
                        ></Slider
                    ></FormItem>
                </Form>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
        <!-- 编辑选项 -->
        <Modal
            v-model="edit_modal"
            title="编辑选项"
            width="480"
            :mask-closable="false"
        >
            <Form label-position="left" :label-width="80">
                <FormItem label="选项名称">
                    <Input v-model="optionName" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="设置选项">
                    <div class="option-list">
                        <div
                            class="option-item"
                            v-for="(o, i) in optionList"
                            :key="i"
                        >
                            <Input
                                v-model="o.name"
                                placeholder="请输入"
                            ></Input>
                            <Icon
                                type="ios-close-circle"
                                class="option-del"
                                @click="delOption(i)"
                            />
                        </div>
                        <div class="option-add" @click="addOption">
                            <Icon type="md-add" size="18" color="#FF761D" />
                            <span>添加选项</span>
                        </div>
                    </div>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelOption">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitOption"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            // 列类型
            fieldTypes: [
                { id: 1, name: "单选项" },
                { id: 2, name: "文本" },
                { id: 3, name: "数字" },
                { id: 4, name: "手机号" },
                { id: 5, name: "地址" },
                { id: 6, name: "身份证" },
                { id: 7, name: "性别" },
                { id: 8, name: "日期" },
            ],
            // 编辑选项弹窗
            edit_modal: false,
            currentIndex: -1,
            optionName: "",
            optionList: [],
        };
    },
    methods: {
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        // 添加字段（按列类型）
        addField(name) {
            var label;
            if (name == 1) {
                label = "单选项";
            } else if (name == 2) {
                label = "文本";
            } else if (name == 3) {
                label = "数字";
            } else if (name == 4) {
                label = "手机号";
            } else if (name == 5) {
                label = "地址";
            } else if (name == 6) {
                label = "身份证";
            } else if (name == 7) {
                label = "性别";
            } else if (name == 8) {
                label = "日期";
            }
            const item = {
                label: label,
                value: "",
                type: name,
            };
            // 单选项默认初始化一个选项
            if (name === 1) {
                item.options = [{ name: "选项一" }];
            }
            this.newFormData.content.table_list.push(item);
        },
        // 打开编辑选项弹窗
        openEditOption(index) {
            const item = this.newFormData.content.table_list[index];
            if (!item) return;
            this.currentIndex = index;
            this.optionName = item.label || "";
            const options = Array.isArray(item.options) ? item.options : [];
            this.optionList = JSON.parse(JSON.stringify(options));
            if (!this.optionList.length) {
                this.optionList.push({ name: "" });
            }
            this.edit_modal = true;
        },
        // 添加选项
        addOption() {
            this.optionList.push({ name: "" });
        },
        // 删除选项
        delOption(i) {
            if (this.optionList.length <= 1) {
                this.$Message.info("至少保留一个选项");
                return;
            }
            this.optionList.splice(i, 1);
        },
        // 确定：保存选项
        submitOption() {
            const item = this.newFormData.content.table_list[this.currentIndex];
            if (item) {
                item.label = this.optionName;
                item.options = JSON.parse(JSON.stringify(this.optionList));
            }
            this.edit_modal = false;
        },
        // 取消
        cancelOption() {
            this.edit_modal = false;
        },
        // 根据列类型返回类型名
        fieldTypeLabel(e) {
            if (e && e.type) {
                const type = this.fieldTypes.find((item) => item.id === e.type);
                return type ? type.name : "文本";
            }
            return "";
        },
        // 删除
        delIcon(i) {
            if (this.newFormData.content.table_list.length == 1) {
                this.$Message.info("至少保留一个");
            } else {
                this.newFormData.content.table_list.splice(i, 1);
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.table-box {
    padding: 0 12px;
    margin-bottom: 6px;
    height: 40px;
    border: 1px solid #c0c4cc;
    border-radius: 4px;
    font-size: 15px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.add-status {
    margin-bottom: 24px;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff761d;
    cursor: pointer;
    font-size: 15px;
    border: 1px solid #ff761d;
    border-radius: 4px;
}
.add-status span {
    margin-left: 4px;
    line-height: 15px;
}
.field-type {
    margin-right: 8px;
    width: 48px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #ff761d;
    background: #fff4ec;
    border-radius: 2px;
    flex-shrink: 0;
    text-align: center;
}
.table-input {
    flex: 1;
}
.form-label {
    margin: 24px 0 12px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.c-p {
    cursor: pointer;
}
.edit-option {
    margin: 0 8px;
    padding: 3px 6px;
    display: flex;
    align-items: center;
    color: #999;
    cursor: pointer;
    font-size: 13px;
    border: 1px solid #ccc;
    border-radius: 4px;
    line-height: 13px;
}
.option-list {
    width: 100%;
}
.option-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}
.option-item ::v-deep .ivu-input-wrapper {
    flex: 1;
}
.option-del {
    margin-left: 8px;
    font-size: 20px;
    color: #ed4014;
    cursor: pointer;
}
.option-add {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff761d;
    cursor: pointer;
    font-size: 14px;
    border: 1px solid #ff761d;
    border-radius: 4px;
    width: 100px;
}
.option-add span {
    margin-left: 4px;
}
.w50 {
    margin: 0 6px;
    width: 50px;
}
.ml50 {
    margin-left: 50px;
}
</style>
